module.exports = __webpack_public_path__ + "img/ss.08d2cc41.svg";